import { Tab as bootstrapTab } from 'bootstrap';

const url = location.href.replace(/\/$/, "");
const pageUrl = url.split("#")[0];

class SmartTabs {

    constructor(el) {
        this.el = el;
        this.tabs = el.querySelectorAll('.nav-link');
        // update page url anchor when tabs changed
        if(this.tabs != null) {
            this.tabs.forEach(t => {
                let tabID = null;
                if(t.getAttribute('href')) {
                    tabID = t.getAttribute('href');
                } else if(t.dataset.bsTarget) {
                    tabID = t.dataset.bsTarget;
                }
                // update url and history on tab active
                t.addEventListener('shown.bs.tab', function (event) {
                    let url = null;
                    if(event.target.getAttribute('href')) {
                        url = pageUrl + tabID;
                    } else if(event.target.dataset.bsTarget) {
                        url = pageUrl + tabID;
                    }
                    if(url) history.replaceState(null, null, url);
                })
                // add listeners for links to tab
                let findLinksToTabs = document.querySelectorAll(`a:not(.nav-link)[href="${tabID}"]`);
                findLinksToTabs.forEach(l => {
                    l.addEventListener('click', (e) => {
                        let tab = bootstrapTab.getOrCreateInstance(t);
                        if(tab != null) {
                            e.preventDefault();
                            tab.show();
                            // focus on first focusable element inside tab content
                            let firstEl = document.querySelector(tabID).querySelector('a,button,input,textarea,select,details,[tabindex]:not([tabindex="-1"]');
                            if(firstEl != null) firstEl.focus();
                        }
                    });
                });
            });
        }
    }

}

// export the default function to create
export function createFrom(wrappers) {

    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new SmartTabs(node);
        }
    });

    // set active tab on page load?
    if (location.hash) {
        let hash = url.split("#")[1];
        if(hash.length > 0) {
            let findNav = document.querySelector(`.nav-link[href="#${hash}"]`);
            if(!findNav) {
                findNav = document.querySelector(`.nav-link[data-bs-target="#${hash}"]`);
            }
            if(findNav != null) {
                let tab = bootstrapTab.getOrCreateInstance(findNav);
                tab.show();
            }
        }
    }

}